import { createFileRoute } from "@tanstack/react-router";

import { loadVisitDossier } from "@/customers/loadVisitDossier";
import { VisitDossierPage } from "@/customers/VisitDossierPage";
import { pageTitle } from "@/i18n/title";

export const Route = createFileRoute(
  "/_authed/customers/$customerId/visits/$visitId/dossier"
)({
  head: () => pageTitle("Pre-visit dossier"),
  loader: ({ context: { queryClient }, params }) =>
    loadVisitDossier(queryClient, params),
  component: VisitDossierPage,
});
